import { FunctionComponent } from "react";
import {
  ButtonType,
  StyledButton,
  StyledContent,
  StyledLoader,
} from "./button.styles";
import Icon from "./icon";
import { faSpinner, IconType } from "./icon-library";

interface ButtonProps {
  children: any;
  className?: string;
  name?: string;
  submit?: boolean;
  disabled?: boolean;
  loading?: boolean;
  type: ButtonType;
  form?: string;

  // not needed on forms?
  onClick?: () => void;

  // icons
  preIcon?: IconType;
  postIcon?: IconType;
}

const Button: FunctionComponent<ButtonProps> = ({
  children,
  className,
  name,
  submit = false,
  disabled = false,
  onClick = () => {},
  loading = false,
  type,
  form,
  preIcon,
  postIcon,
}) => {
  return (
    <StyledButton
      className={className}
      name={name}
      disabled={disabled}
      onClick={onClick}
      type={submit ? "submit" : "button"}
      $loading={loading}
      $type={type}
      form={form}
    >
      <StyledContent $loading={loading}>
        {preIcon && <Icon icon={preIcon} />}
        {children}
        {postIcon && <Icon icon={postIcon} />}
      </StyledContent>
      <StyledLoader $loading={loading}>
        <Icon icon={faSpinner} />
      </StyledLoader>
    </StyledButton>
  );
};

export default Button;
